/**
 * @class TextUtil
 * @description Class used for formatting text.
 * @author Edmark Santos
 * @version 1.0
 * @since November 14, 2019
 */
export default class TextUtil {
  /**
   * @function titleCase
   * @description Method for making text in title case format.
   * @param {Integer} text - Text to be formatted.
   * @returns {String} Formatted text in title case.
   */
  toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  formatToTitleCase(text) {
    if (!text) return "";
    return this.toTitleCase(text);
  }

  capitalizeFirstLetter(string) {
    return string ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : "";
  }

  getInitials(string) {
    if (!string) return "";
    return string
      .toUpperCase()
      .split(/\s+/)
      .map((word) => word.charAt(0))
      .slice(0, 2)
      .join("");
  }
}
